module.exports = __webpack_public_path__ + "static/img/BT.c15edb21.png";